export default __webpack_public_path__ + "static/media/a19.2546fd0f.jpg";